(function (upp) {
    'use strict';

    upp.directive('modalEmailRestoreTpl', ['$timeout', 'restoreService',
        function ($timeout, restoreService) {
            var modal,
                _restorePassword = function (scope) {
                    restoreService.restorePassword(scope['email'])
                        .then(function () {
                            scope.restoreError = false;
                            scope.restoreSent = true;

                            $timeout(function () {
                                modal.modal('hide');
                            }, 2000);
                        }, function () {
                            scope.restoreError = true;
                        });
                },
                _resetModel = function (scope) {
                    scope.restoreError = false;
                    scope.restoreSent = false;
                    scope.email = '';
                };

            return {
                restrict: 'E',
                replace: true,
                templateUrl: require('../templates/modal-email-restore-tpl.html'),
                controller: ['$scope', function ($scope) {
                    $scope.email = '';

                    $scope.restore = function () {
                        _restorePassword($scope);
                    };
                }],
                link: function (scope, element) {
                    // open the modal
                    scope.$on('emailRestore:open', function () {
                        modal = modal || element;

                        _resetModel(scope);
                        scope.email = '';
                        modal.modal('show');
                        modal.one('shown', function () {
                            $('#email').unbind('mouseup mousedown');
                        });

                        // send event
                        modal.one('hidden', function () {
                            $timeout(function () {
                                scope.$broadcast('emailRestore:close');
                            }, 500);

                        });

                        // submit with ENTER key
                        modal.unbind('keypress').bind('keypress', function (event) {
                            if (event.which == 13) {
                                event.preventDefault();
                                _restorePassword(scope);
                            }
                        });

                        // close the modal
                        scope.$on('emailRestore:close', function () {
                            modal.modal('hide');
                        });
                    });
                }
            }
        }]);

}(upp));


// WEBPACK FOOTER //
// ./src/app/plugins/login/directives/modal-email-restore-tpl_directive.js